import { render, staticRenderFns } from "./assets-section.vue?vue&type=template&id=c81b9d62&scoped=true"
import script from "./assets-section.vue?vue&type=script&lang=ts"
export * from "./assets-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81b9d62",
  null
  
)

export default component.exports